import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { IMonitoringRequest } from '../interfaces/monitoring-request.interface';
import { IMonitoringResponse } from '../interfaces/monitoring-response.interface';

@Injectable({ providedIn: 'root' })
export class MonitoringService {
  private http = inject(HttpClient);
  private readonly api = environment.gateway.url;

  fetchMonitoring(query: IMonitoringRequest) {
    let params = new HttpParams();

    Object.entries(query as object)
      .filter(([, value]) => this.isNotEmpty(value))
      .forEach(([key, value]) => {
        params = params.append(key, value);
      });

    console.log({ params });
    return this.http.get<IMonitoringResponse>(`${this.api}/catalog-dialect/v1/monitoring/products-search`, { params });
  }

  private isNotEmpty(value: unknown) {
    if (value === null || typeof value === 'undefined') return false;

    if (typeof value === 'string' && String(value).trim().length === 0) return false;

    if (Array.isArray(value) && !value.length) return false;

    return true;
  }
}
